import React from 'react'

function Rep_DoctorPerformanceReports() {
  return (
    <div>Doctor Performance Reports</div>
  )
}

export default Rep_DoctorPerformanceReports